import { useParams, useSearchParams } from "react-router-dom";
import { useDoesUserHaveRole } from "../../../hooks/permissions";
import { UserRole } from "../../user-management/types/user-management.types";
import { useFetchClientBasicAndPersonalInfo } from "../../../hooks/queries/client";
import { displayNameInRightFormat } from "../../../utils/helpers";
import { useFetchUserDetails } from "../../../hooks/queries/user";
import { BillStatus } from "../types/billing.types";
import { getBillStatusLabel } from "../helpers/billing.helpers";

export function usePendingResolutionDialogText() {
    const [searchParams] = useSearchParams();
    const isCardDeclined = searchParams.get("payment_failed") === "true";

    return isCardDeclined
        ? "Mark as Card Payment Declined"
        : "Mark as Pending session fee";
}

export function useCanSetClientBiller() {
    return useDoesUserHaveRole([
        UserRole.BILLER,
        UserRole.BILLER_ADMIN,
        UserRole.SUPER_ADMIN,
    ]);
}

export function useCanSetAnyClientBiller() {
    return useDoesUserHaveRole([UserRole.SUPER_ADMIN, UserRole.BILLER_ADMIN]);
}

export const useGetClientCanByChargedByText = () => {
    const { clientId } = useParams();

    const loggedInUser = useFetchUserDetails();

    const { data } = useFetchClientBasicAndPersonalInfo(
        clientId || "",
        Boolean(clientId)
    );

    if (data?.data?.client_can_be_charged_by?.user_id) {
        if (
            data?.data?.client_can_be_charged_by?.user_id ===
            loggedInUser?.data?.user_id
        ) {
            return "You";
        }
        return displayNameInRightFormat({
            firstName: data?.data?.client_can_be_charged_by?.first_name || "",
            lastName: data?.data?.client_can_be_charged_by?.last_name || "",
        });
    }

    return "All";
};

export function useSortedBillStatuses() {
    return Object.values(BillStatus).sort((a, b) =>
        getBillStatusLabel(a).localeCompare(getBillStatusLabel(b))
    );
}
